import { render, staticRenderFns } from "./BlackshipForm.vue?vue&type=template&id=6e7ecb0e&scoped=true&"
import script from "./BlackshipForm.vue?vue&type=script&lang=js&"
export * from "./BlackshipForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7ecb0e",
  null
  
)

export default component.exports